module.exports = __webpack_public_path__ + "img/cw.3f0d8f91.svg";